/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_No_DeckInputs */



/**
* | output |
* | --- |
* | "No deck uploaded" |
*
* @param {Players_No_DeckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_no_deck = /** @type {((inputs?: Players_No_DeckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_No_DeckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun deck téléchargé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin deck cargado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum deck enviado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun deck caricato")
	return /** @type {LocalizedString} */ ("No deck uploaded")
});